import http from "../http-common";

class ConvergenceCarouselSlidesService {
  getConvergenceCarouselSlides() {
    return http.get("/banners/hero-primary");
  }
}

export default new ConvergenceCarouselSlidesService();
